import { createContext, useContext, useState, useCallback } from "react";
import { track } from "../api";

const FlowContext = createContext(null);

export const FlowProvider = ({ children }) => {
  const [client, setClient] = useState({ open: false, category: null });
  const [proOpen, setProOpen] = useState(false);
  const [reviewRef, setReviewRef] = useState(null);

  const openClient = useCallback((category = null) => {
    track("cta_help_click", category || "");
    track("request_form_start", category || "");
    setClient({ open: true, category });
  }, []);
  const closeClient = useCallback(() => setClient({ open: false, category: null }), []);
  const openPro = useCallback(() => setProOpen(true), []);
  const closePro = useCallback(() => setProOpen(false), []);
  const openReview = useCallback((ref) => setReviewRef(ref), []);
  const closeReview = useCallback(() => setReviewRef(null), []);

  return (
    <FlowContext.Provider value={{ client, openClient, closeClient, proOpen, openPro, closePro, reviewRef, openReview, closeReview }}>
      {children}
    </FlowContext.Provider>
  );
};

export const useFlow = () => {
  const ctx = useContext(FlowContext);
  if (!ctx) throw new Error("useFlow must be used within FlowProvider");
  return ctx;
};
